import { render, staticRenderFns } from "./SearchAdvertPiano.vue?vue&type=template&id=4b1c8872&scoped=true"
import script from "./SearchAdvertPiano.vue?vue&type=script&lang=js"
export * from "./SearchAdvertPiano.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1c8872",
  null
  
)

export default component.exports